import { api } from "../utils/api";
import type {
  RestCreateUnit,
  RestUnit,
  RestUpdateUnit,
} from "@KassaroAB/shared/types/unit";
import type { UnitId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const unitsPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "units");

export const getUnitsApi = (scope: CatalogScope): Promise<RestUnit[]> => {
  return api.get(unitsPath(scope));
};

export const getUnitApi = (
  scope: CatalogScope,
  unitId: UnitId,
): Promise<RestUnit> => {
  return api.get(`${unitsPath(scope)}/${unitId}`);
};

export const createUnitApi = (
  scope: CatalogScope,
  unit: RestCreateUnit,
): Promise<RestUnit> => {
  return api.post(unitsPath(scope), unit);
};

export const updateUnitApi = (
  scope: CatalogScope,
  unitId: UnitId,
  unit: RestUpdateUnit,
): Promise<RestUnit> => {
  return api.put(`${unitsPath(scope)}/${unitId}`, unit);
};

export const deleteUnitApi = (
  scope: CatalogScope,
  unitId: UnitId,
): Promise<void> => {
  return api.delete(`${unitsPath(scope)}/${unitId}`);
};
